export default "__VITE_ASSET__B0cA2uII__"